'use client'

import type { NamespacesPossibleKeys } from '@/lib/i18n/types'
import { useTranslation } from '@/lib/i18n/useTranslation.client'

type ProductStatusLineTransProps = {
  i18nKey: NamespacesPossibleKeys<'productAvailabilities'>
  values?: Record<string, string | number | undefined>
  textTint?: string
  shortMode?: boolean
}

export function ProductStatusLineTrans({
  i18nKey,
  values,
  textTint,
  shortMode = false,
}: ProductStatusLineTransProps) {
  const { t, Trans } = useTranslation(['productAvailabilities', 'checkout'])

  return (
    <div className={shortMode ? 'line-clamp-1' : ''} data-testid="product-availability-trans">
      <Trans
        i18nKey={i18nKey}
        values={{
          ...(values?.pluralCount !== undefined && {
            available: t('productAvailabilities:store.available.available', {
              count: Number(values.pluralCount) || 0,
            }),
            products: t('productAvailabilities:store.products.product', {
              count: Number(values.pluralCount) || 0,
            }),
            allProducts: t('productAvailabilities:store.allYourProducts.allYourProducts', {
              count: Number(values.pluralCount) || 0,
            }),
          }),
          ...values,
        }}
        components={{
          bold: <span className="font-bold" />,
          tint: <span className={textTint} data-testid="trans-text-tint" />,
          limitedstock: (
            <span className={!values?.onlineQuantity && !values?.maxQuantity ? 'hidden' : ''} />
          ),
          pointOfSale: <span className={!values?.pointOfSaleName ? 'hidden' : ''} />,
        }}
      />
    </div>
  )
}
